import React from 'react';
import style from './style.module.scss';

export interface SectionHeaderProps {
    title: string;
    /** Muted descriptor shown beside the title (e.g. "hero KPIs · number + delta"). */
    subtitle?: string;
    /** Optional control rendered at the far right of the header row. */
    action?: React.ReactNode;
}

/**
 * Row heading for a dashboard section: a bold title with an optional muted
 * subtitle beside it, and an optional right-aligned action slot.
 */
export const SectionHeader = ({
    title,
    subtitle,
    action,
}: SectionHeaderProps) => (
    <div className={style.section_header}>
        <h2 className={style.section_title}>
            {title}
            {subtitle && (
                <span className={style.section_subtitle}>{subtitle}</span>
            )}
        </h2>
        {action && <div className={style.section_action}>{action}</div>}
    </div>
);
